var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$route.query.viewMsg)?_c('info'):_c('msg')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }